<template>
  <div>
    <!-- Barre d'outils avec onglets -->
    <v-toolbar dense tabs color="primary darken-2" dark class="page_title">
      <v-toolbar-title class="pa-0 pr-0 mt-1">
        <v-layout row>
          <v-flex xs10 sm11 text-xs-left>
            <!-- Flèche retour en JS -->
            <v-btn flat fab small class="pa-0" @click="goBack">
              <i class="fas fa-arrow-left headline"></i>
            </v-btn>
            Vendor Marketplace
          </v-flex>
          <v-flex xs2 sm1 text-xs-right>
            <!-- Croix vers business dashboard -->
            <v-btn flat fab small class="pa-0" @click="goToDashboard">
              <i class="fas fa-close headline"></i>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Onglets masqués si pas encore seller -->
      <v-tabs
        v-if="isSeller"
        v-model="tabs"
        color="transparent"
        slider-color="white"
        slot="extension"
      >
        <v-tab v-for="tabsItem in sellerTabs" :key="tabsItem.id" :to="tabsItem.link">
          <span class="pl-1 pr-1">{{ tabsItem.title }}</span>
        </v-tab>
      </v-tabs>

      <!-- Message si pas encore approuvé -->
      <div v-else slot="extension" class="px-3 py-2 grey--text text--lighten-2">
        <small><v-icon small class="mr-1">info</v-icon> Waiting for vendor approval</small>
      </div>
    </v-toolbar>

    <!-- Contenu dynamique -->
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <v-slide-y-transition mode="out-in">
            <router-view />
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SellerLayout',

  data() {
    return {
      tabs: null,
      isSeller: false,
      // Onglets spécifiques au seller
      sellerTabs: [
        {
          id: 1,
          title: "Dashboard",
          link: "/business-account/market_place/seller/dashboard",
        },
        {
          id: 2,
          title: "Products",
          link: "/business-account/market_place/seller/products",
        },
        {
          id: 3,
          title: "Add Product",
          link: "/business-account/market_place/seller/add-product",
        }
      ],
    };
  },

  mounted() {
    document.title = "Seller Marketplace";
    this.checkSellerStatus();
  },

  methods: {
    async checkSellerStatus() {
      try {
        const response = await axios.get('/api/v1/market_place/seller/check-status/')
        this.isSeller = response.data.is_seller === true
      } catch (error) {
        console.error('Error checking seller status:', error)
        this.isSeller = false
      }
    },

    goBack() {
      if (window.history.length > 2) {
        this.$router.back()
      } else {
        this.$router.push('/business-account/market_place/seller/dashboard')
      }
    },

    goToDashboard() {
      this.$router.push('/business-account/dashboard')
    }
  }
};
</script>

<style scoped>
.page_title {
  position: sticky;
  top: 0;
  z-index: 5;
}
</style>
